/**
 * Pull a readable message out of anything that got thrown.
 *
 * Supabase rejects with plain objects (PostgrestError, StorageError, AuthError)
 * rather than Error instances, so `String(error)` on one of those yields
 * "[object Object]" — which is exactly the sort of thing that ends up on a
 * user's screen at the worst moment.
 */
export function errorMessage(error: unknown, fallback = "Something went wrong"): string {
  if (error instanceof Error && error.message) return error.message;

  if (error && typeof error === "object") {
    const candidate = error as { message?: unknown; error_description?: unknown; error?: unknown };
    for (const value of [candidate.message, candidate.error_description, candidate.error]) {
      if (typeof value === "string" && value) return value;
    }
  }

  if (typeof error === "string" && error) return error;
  return fallback;
}
